/**
 * @generated SignedSource<<b7486e8f8f556e6490a54e7a41fe0662>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RatesAndInternalCostLitePage_company$data = {
  readonly id: string;
  readonly currency: string | null;
  readonly " $fragmentType": "RatesAndInternalCostLitePage_company";
};
export type RatesAndInternalCostLitePage_company$key = {
  readonly " $data"?: RatesAndInternalCostLitePage_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"RatesAndInternalCostLitePage_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RatesAndInternalCostLitePage_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "53fe65a4967f3cea68719b3ff09f1710";

export default node;
